import PropTypes from 'prop-types'
import { createSelector } from 'reselect'

import {
  DefaultTopicDemographicsState
} from '../reducers/topicDemographics_reducer'

// -----------------------------------------------------------------------------

// Topic Plan Segments Selectors

// -----------------------------------------------------------------------------

/* Fetches the segments by id, assuming an id is in the url */
const getTopicDemographics = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return (state.topics.byId[topicId] || {}).demographics
}

/* Smartly returns the segments or the default state */
const getTopicDemographicsState = createSelector(
  [getTopicDemographics],
  (demographics) => {
    return demographics || DefaultTopicDemographicsState
  }
)

const TopicDemographicsPropType = PropTypes.shape({
  percent_gender: PropTypes.number.isRequired,
  percent_age: PropTypes.number.isRequired
})

const makeTopicPlanDemographics = () => {
  return createSelector(
    [getTopicDemographicsState],
    (demographics) => {
      return {
        isFetching: demographics.isFetching || demographics.didInvalidate || !demographics.details,
        error: demographics.error,
        details: demographics.details
      }
    }
  )
}

// -----------------------------------------------------------------------------

// Exports

// -----------------------------------------------------------------------------

export {
  makeTopicPlanDemographics,
  TopicDemographicsPropType
}
